import { render, staticRenderFns } from "./ParkingComments.vue?vue&type=template&id=575ed398&scoped=true"
import script from "./ParkingComments.vue?vue&type=script&lang=js"
export * from "./ParkingComments.vue?vue&type=script&lang=js"
import style0 from "./ParkingComments.vue?vue&type=style&index=0&id=575ed398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575ed398",
  null
  
)

export default component.exports